import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { UserRefundState, UserRefundType } from './data';
import { getUserRefundPage } from './service';

type UserRefundModelType = {
  namespace: string;
  state: UserRefundState;
  reducers: {
    UserRefundReducer: Reducer<UserRefundState>;
  };
  effects: {
    fetchUserRefundPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const UserRefundModel: UserRefundModelType = {
  namespace: 'userRefund',
  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  reducers: {
    UserRefundReducer(state, action) {
      const payload = action.payload || {};
      const items = payload.data?.items;
      return {
        ...state,
        ...payload,
        items: Array.isArray(items) ? items : [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as UserRefundState;
    },
  },

  effects: {
    *fetchUserRefundPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getUserRefundPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'UserRefundReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.userRefund.current);
      const pageSize = yield select((state: any) => state.userRefund.pageSize);
      yield put({
        type: 'fetchUserRefundPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },
  },

  subscriptions: {
    setup() {},
  },
};

export default UserRefundModel;
